export interface PersonAttributes {
  name: string;
  email?: string | null;
  phoneNumber?: string | null;
  photoURL?: string | null;
  birthday?: string | null;
  gender?: string | null;
  medicalNotes?: string | null;
}

export interface Person {
  id: string;
  churchID: string;
  attributes: PersonAttributes;
}

/// A page of people, cursored on the last person in the page.
export interface PeopleSearchResult {
  results: Person[];
  hasMore: boolean;
  nextLastPersonID?: string | null;
}

// The single-person envelope isn't pinned down yet; accept a result wrapper or
// the person on its own.
export function personFromResponse(body: unknown): Person | null {
  if (!body || typeof body !== 'object') {
    return null;
  }

  const payload = body as Record<string, any>;
  const candidate = payload.result ?? payload.person ?? payload;

  if (!candidate || typeof candidate !== 'object' || !candidate.attributes?.name) {
    return null;
  }

  return candidate as Person;
}
